"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventExtraInfo = /** @class */ (function () {
    function EventExtraInfo() {
        this.uniquePlace = true;
        this.uniqueVoucher = true;
        this.uniquePrice = true;
        this.freePass = false;
        this.isOnline = false;
        this.showInfoOnBackground = true;
        this.showMapOnSite = true;
    }
    return EventExtraInfo;
}());
exports.EventExtraInfo = EventExtraInfo;
//# sourceMappingURL=event-extra-info.js.map